import { useQuery } from '@tanstack/react-query';

import { categoryBreadcrumbsQueryOptions } from '@/modules/breadcrumbs/queryOptions';
import { useBrandBreadcrumbs } from '@/modules/breadcrumbs/useBrandBreadcrumbs';
import { getProductBreadcrumbsArgs } from '@/modules/product/helpers/getProductBreadcrumbsArgs';
import { getProductBreadcrumbsBrand } from '@/modules/product/helpers/getProductBreadcrumbsBrand';
import { useProductBySlugBasicPDP } from '@/modules/product/hooks/useProductBySlugBasicPDP';

export function useProductBreadcrumbs() {
  const { data: product, isLoading: isProductLoading } =
    useProductBySlugBasicPDP();
  const brandBreadcrumbs = useBrandBreadcrumbs(
    getProductBreadcrumbsBrand(product)
  );
  const { data: categoryBreadcrumbs = [], isLoading: isBreadcrumbsLoading } =
    useQuery(
      categoryBreadcrumbsQueryOptions(getProductBreadcrumbsArgs(product))
    );

  return {
    breadcrumbs: [...brandBreadcrumbs, ...categoryBreadcrumbs],
    isLoading: isProductLoading || isBreadcrumbsLoading,
  };
}
